<template>
  <div class="header w1200">
    <img class="logo" src="../assets/logo.png" alt="" />
    <div class="navigation">
      <div
        v-for="(item, index) in navigation"
        :key="item.path"
        :class="{ active: index == isActive }"
        @click="change(item, index)"
      >
        {{ item.text }}
      </div>
    </div>
    <div class="header_right">
      <img src="../assets/phone.png" alt="" />
      <span class="phone">0532-68002636</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "tab",
  data() {
    return {
      navigation: [
        {
          text: "首页",
          path: "/",
          id: 0
        },
        {
          text: "关于我们",
          path: "/about",
          id: 1
        },
        {
          text: "产品解决方案",
          path: "/product",
          id: 2
        },
        {
          text: "业绩与能力",
          path: "/achievement",
          id: 3
        },
        {
          text: "合作伙伴",
          path: "/partner",
          id: 4
        },
        {
          text: "联系我们",
          path: "/contactus",
          id: 5
        }
      ],
      isActive: 0,
      from: "/"
    };
  },
  watch: {
    $route: {
      handler(val, oldval) {
        this.from = val.path;
        if (val.path == "/det") {
          this.isActive = "2";
        } else {
          this.isActive = this.navigation.find(
            item => item.path == val.path
          ).id;
        }
      },
      deep: true
    }
  },
  methods: {
    change(e, e1) {
      this.isActive = e1;
      if (this.from != e.path) {
        this.$router.push(e.path);
      }
    }
  }
};
</script>
<style>
.header {
  height: 100px;
  display: flex;
  padding: 0 34px;
  justify-content: space-between;
  align-items: center;
}
.header .logo {
  width: 162px;
  height: 62px;
}

.header .phone {
  color: #3783e9;
  font-size: 20px;
  margin-left: 8px;
}

.header_right img {
  width: 26px;
  height: 26px;
  margin-bottom: -6px;
}

.navigation {
  display: flex;
}
.navigation div {
  height: 60px;
  padding: 0 4px;
  line-height: 60px;
  font-size: 16px;
  color: #333;
  margin-right: 24px;
  /* font-weight: bold; */
  font-family: "SourceHanSansCN-Bold";
  cursor: pointer;
}
.navigation div.active {
  color: #3783e9;
  border-bottom: 3px solid #3783e9;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue